// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1efSK","content":"ManualTimeModal_content__2b1Qk"};